import { render } from "./EducationList.vue?vue&type=template&id=461c008b"
import script from "./EducationList.vue?vue&type=script&lang=js"
export * from "./EducationList.vue?vue&type=script&lang=js"

import "./EducationList.vue?vue&type=style&index=0&id=461c008b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__